import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import { Card, Tabs } from 'antd';

import { getTranslatedString } from 'helpers/i18n';

import { IncentivesContext } from '../LandlordIncentives';

import IncentiveTemplateForm from './components/IncentiveTemplateForm';
import ActionButtons from './components/Form/ActionButtons';
import Configuration from './components/Form/Configuration';
import History from './components/Form/History';
import { AntdPageHeader, ContentWrapper, ApplicationUIContext, AntdTag } from '@yuhuinc/ui-library';

const FORM_NAME = 'edit_fee_template_form';

const EditIncentiveTemplate = ({
  onBack,
  onArchive,
  onUpdate,
  onPublish,
  onRepublish,
  onDelete,
}) => {
  const { isMobile } = useContext(ApplicationUIContext);

  const incentivesData = useContext(IncentivesContext);
  const { currentIncentiveTemplate, loading } = incentivesData;

  return (
    <IncentiveTemplateForm formData={currentIncentiveTemplate}>
      {(formProps) => (
        <>
          <AntdPageHeader
            onBack={onBack}
            title={getTranslatedString('landlordPortal.incentives.editIncentiveTemplate')}
            tags={<AntdTag status={formProps.values.status} />}
            style={{ paddingBottom: 0 }}
            extra={
              <ActionButtons
                loading={loading}
                form={formProps}
                onArchive={onArchive}
                onUpdate={onUpdate}
                onPublish={onPublish}
                onRepublish={onRepublish}
                onDelete={onDelete}
              />
            }
          />
          <ContentWrapper>
            <Tabs defaultActiveKey="configuration">
              <Tabs.TabPane
                tab={getTranslatedString('landlordPortal.incentives.configuration')}
                key="configuration"
              >
                <Card
                  style={{ maxWidth: 744 }}
                  bodyStyle={{ padding: isMobile && 16, fontSize: isMobile && 16 }}
                >
                  <Configuration {...formProps} formName={FORM_NAME} />
                </Card>
              </Tabs.TabPane>
              <Tabs.TabPane
                tab={getTranslatedString('landlordPortal.incentives.history')}
                key="history"
              >
                <Card
                  style={{ maxWidth: 768 }}
                  bodyStyle={{ padding: isMobile && 16, fontSize: isMobile && 16 }}
                >
                  <History />
                </Card>
              </Tabs.TabPane>
            </Tabs>
          </ContentWrapper>
        </>
      )}
    </IncentiveTemplateForm>
  );
};

EditIncentiveTemplate.propTypes = {
  onBack: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired,
};

export default EditIncentiveTemplate;
